import { httpClient } from '../lib/http-client';
import { Tag, Ticket } from '../types';

/**
 * Service para gerenciamento de tags
 */
export class TagsService {
  static async getTags(): Promise<Tag[]> {
    return httpClient.get<Tag[]>('/api/tags');
  }

  static async getTag(id: number): Promise<Tag> {
    return httpClient.get<Tag>(`/api/tags/${id}`);
  }

  static async createTag(data: Partial<Tag>): Promise<Tag> {
    return httpClient.post<Tag>('/api/tags', data);
  }

  static async updateTag(id: number, data: Partial<Tag>): Promise<Tag> {
    return httpClient.put<Tag>(`/api/tags/${id}`, data);
  }

  static async deleteTag(id: number): Promise<{ success: boolean; message?: string }> {
    return httpClient.delete<{ success: boolean; message?: string }>(`/api/tags/${id}`);
  }

  static async getTicketsPorTag(tagId: number): Promise<Ticket[]> {
    return httpClient.get<Ticket[]>(`/api/tags/${tagId}/tickets`);
  }
}

